import styled from 'styled-components';

const InputWrapper = styled.div`
  margin: -${({ theme }) => theme.spacing.x2};
  display: flex;
  flex-wrap: wrap;
`;

export const ProfileFormInputWrapper = styled(InputWrapper)`
  > * {
    padding: ${({ theme }) => theme.spacing.x2};
    width: 33.333%;
    @media (max-width: ${({ theme }) => theme.media.xl}) {
      width: 50%;
    }
    @media (max-width: ${({ theme }) => theme.media.lg}) {
      width: 100%;
    }
  }
`;

export const ButtonWrapper = styled.div`
  margin: 10px 0px;
`;
export const Button = styled.div`
  margin: 0 ${({ theme }) => theme.spacing.x2};
  width: 120px;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    width: 50%;
    margin: 1px;
  }
`;

export const ButtonApply = styled.button`
  color: #fff !important;
`;
